export const ENABLE_PAYMENT_METHOD_NOTE =
  'I verify. If the method is selected as Default method, this method will be used in auto-charge'

export const getActorDisplayName = historyEntry =>
  historyEntry.disableSource === 'Auto' || historyEntry.addedByUserId < 0
    ? 'System'
    : historyEntry.addedByFullName ||
      (historyEntry.addedByUserId != null ? historyEntry.addedByUserId : 'System')

export const isDisableNoteValid = note => Boolean(note.trim())
